import * as jsxRuntime from "D:\\CodexData\\worktrees\\member-coupon-scope\\kuban-web\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment